export const FEE_CURRENCY = {
  ALL: "ALL",
};

export const feeCurrencyLabels = {
  [FEE_CURRENCY.ALL]: "All",
};

export const feeCurrencyFormOptions = [
  { value: FEE_CURRENCY.ALL, label: feeCurrencyLabels[FEE_CURRENCY.ALL] },
];
